<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Orders</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item active">Deliveries
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="card">
                <div class="card-header">
                    <h4>Deliveries</h4>
                </div>

                <div class="card-body">
                    <form>
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="category">By Order ID</label>
                                    <input name="order_no" id="category" class="form-control form-control-sm"
                                           type="text"
                                           v-model="filters.order_no">
                                    <template v-if="errors.order_no">
                                        <small class="text-danger" v-for="error in errors.order_no">
                                            {{ error }}
                                        </small>
                                        <br>
                                    </template>
                                </div>
                            </div>
                            <div class="col-md-12 mb-2">
                                <button type="submit" @click.prevent="paginatedData"
                                        class="btn btn-primary glow mb-1 mb-sm-0">Apply Filter
                                </button>
                                <button type="reset" @click.prevent="resetFilters"
                                        class="btn btn-warning glow mb-1 mb-sm-0">
                                    Reset Filter
                                </button>
                            </div>
                        </div>
                    </form>
                    <vue-good-table
                        class="dataTable"
                        mode="remote"
                        :isLoading.sync="tableDataLoading"
                        :totalRows="totalRecords"
                        :pagination-options="paginationOptions"
                        :sort-options="sortingOptions"
                        @on-page-change="this.onPageChange"
                        @on-per-page-change="this.onPerPageChange"
                        styleClass="vgt-table"
                        :columns="columns"
                        :rows="allDeliveries"
                    >

                        <div slot="emptystate" class="loading-container">
                            <img src="/images/Spinner.svg" alt="">
                        </div>
                        <template slot="table-row" slot-scope="props">
                            <span v-if="props.column.field === 'sn'">
                                {{ serialNo(props) }}
                            </span>
                            <span v-else-if="props.column.field === 'order.order_no'">
                                 <a target="_blank" :href="route('admin.orders.show', props.row.order.id)">{{
                                         props.row.order.order_no
                                     }}</a>
                             </span>
                        </template>
                    </vue-good-table>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import {Link} from '@inertiajs/vue2'
import DeleteAlert from "../../Shared/Mixins/DeleteAlert";
import PaginationMixin from "../../Shared/Mixins/PaginationMixin";
import {formatDateTime} from "../../utils";

export default {
    metaInfo: {title: 'Deliveries'},
    props: [
        'deliveries',
    ],
    layout: Layout,
    name: 'DeliveryIndex',
    components: {
        Link,
    },
    mixins: [
        PaginationMixin,
    ],
    data() {
        return {
            errors: {},
            saving: false,
            filters: {
                order_no: null,
            },
            isLoadingFilter: false,
            allDeliveries: [],
            totalRecords: 0,
            serverParams: {
                page: 1,
                perPage: 100,
                columnFilters: {},
            },
            paginationOptions: {
                enabled: true,
                mode: 'pages',
                perPage: 100,
                perPageDropdown: [5, 10, 20, 50, 100, 200],
                dropdownAllowAll: false,
            },
            sortingOptions: {
                enabled: false,
            },
            columns: [
                {label: 'S/N', field: 'sn', thClass: 'text-center', tdClass: 'text-center'},
                {label: 'Order Number', field: 'order.order_no', thClass: 'text-center', tdClass: 'text-center'},
                {
                    label: 'Dispatch Rider', field: 'rider.first_name',
                    thClass: 'text-center', tdClass: 'text-center',
                    formatFn: this.formatFullName
                },
                {label: 'Assigned Time', field: 'created_at', thClass: 'text-center', tdClass: 'text-center', formatFn: formatDateTime},
                {
                    label: 'Started',
                    field: 'accepted_at',
                    thClass: 'text-center',
                    tdClass: 'text-center',
                    formatFn: formatDateTime,
                },
                {label: 'Completed', field: 'completed_at', thClass: 'text-center', tdClass: 'text-center', formatFn: formatDateTime},
                {
                    label: 'Order Status', field: 'order.status',
                    thClass: 'text-center', tdClass: 'text-center',
                },
                {
                    label: 'Rejection Reason', field: 'rejection_reason',
                    thClass: 'text-center', tdClass: 'text-center',
                },
            ],
            tableDataLoading: false,
        }
    },
    mounted() {
        this.allDeliveries = this.deliveries.data;
        this.totalRecords = this.deliveries.total;
        this.paginationOptions.perPage = this.deliveries.per_page;
        this.serverParams.perPage = this.deliveries.per_page;
        this.serverParams.page = this.deliveries.current_page;
    },

    methods: {
        formatFullName(value, row) {
            return row.rider.first_name + " " + row.rider.last_name
        },
        async paginatedData() {
            try {
                let routeName = route('admin.orders.deliveries');
                this.errors = {};
                let response = await axios.get(routeName, {
                    params: {
                        page: this.serverParams.page,
                        per_page: this.serverParams.perPage,
                        api: true,
                        ...this.filters
                    },
                    headers: {
                        "X-Requested-With": "XMLHttpRequest",
                    },
                });

                this.totalRecords = response.data.total;
                this.paginationOptions.perPage = response.data.per_page;
                this.serverParams.perPage = response.data.per_page;
                this.paginationOptions.setCurrentPage = response.data.page;
                this.allDeliveries = response.data.data
            } catch (error) {
                if (error.response.status === 422) {
                    this.errors = error.response.data.errors;
                } else {
                    console.log(error);
                }
            }
        },
        async resetFilters() {
            for (let filter in this.filters) {
                this.filters[filter] = null;
            }
            await this.paginatedData();
        }
    }
}
</script>
